import { SESSION_STORAGE_PERFORMANCE_DATE_RANGE_KEY } from "./getStoredPerformanceDateRangeFromSession";

export function setStoredPerformanceDateRangeToSession(
  dateRanges: Record<string, { startDate: string; endDate: string }>
) {
  sessionStorage.setItem(
    SESSION_STORAGE_PERFORMANCE_DATE_RANGE_KEY,
    JSON.stringify(dateRanges)
  );
}
